import React, { useState } from 'react'
import { Button,Form,Modal,Input} from 'antd'
function BalanceTypeQuery(props) {
    const [open,setOpen] = useState()
    const [form] = Form.useForm();   
    return (
        <>
            <Button  style={{marginLeft:"15px"}} onClick={() => {setOpen(true)}}>查询</Button>            
            <Modal
                open={open}
                title={`查询${props.title}`}
                okText="提交"
                cancelText="取消"                
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            props.getQuery({
                                efst_finance_type_id:props.type_id,
                                efst_name:values.efst_name,                                                    
                            })                      
                            setOpen(false)
                        })
                        .catch((info) => {
                            console.log('Validate Failed:', info);
                        });
                    
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_in_modal"
                    initialValues={{modifier: 'public',efst_finance_type_id:props.type_id}}
                    labelCol={{ span: 5 }}
                >                                                            
                    <Form.Item 
                        name="efst_name" 
                        label='类型名称' 
                        wrapperCol={{span:15}}
                    >
                        <Input  />
                    </Form.Item>                                                            
                </Form>
            </Modal>
        </>
    )
}

export default BalanceTypeQuery